import React, { useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, ImageIcon, X, Truck } from 'lucide-react';
const allReviews = [
// ===== 253 — Pierce / South Sound =====
{
  name: 'Michael T.',
  role: 'Homeowner',
  location: 'Tacoma, WA',
  region: '253',
  content: 'On time and easy to work with. I needed 5 yards of crushed rock for a driveway extension. They gave me a quote instantly and delivered it the next morning.',
  photo: 'https://cdn.magicpatterns.com/uploads/jqPpSAL3shmbQTsuBx2p1g/Screenshot_20260507-193826.png',
  materialUsed: '5/8" Minus',
  zone: 'Zone 2'
}, {
  name: 'Sarah J.',
  role: 'Landscaping Contractor',
  location: 'Puyallup, WA',
  region: '253',
  content: 'Best pricing in the South Sound. We use them for all our Pierce County projects. They actually show up when they say they will.'
}, {
  name: 'Karen L.',
  role: 'Homeowner',
  location: 'Lakewood, WA',
  region: '253',
  content: 'Ordered a big load of fill dirt for a grading project at our new build. Driver dumped it exactly where we needed it next to the foundation. Saved us a ton of time and the price beat every other quote we got.',
  photo: 'https://cdn.magicpatterns.com/uploads/4nanabaojFe9Pp7KUyTgfL/PXL_20260508_215909413.jpg',
  materialUsed: 'Fill Dirt',
  zone: 'Zone 3'
}, {
  name: 'James R.',
  role: 'General Contractor',
  location: 'Spanaway, WA',
  region: '253',
  content: "Reliable and consistent quality. We've used them on three different job sites this year. The online ordering makes it easy to schedule around our project timelines."
}, {
  name: 'Nicole F.',
  role: 'Homeowner',
  location: 'Gig Harbor, WA',
  region: '253',
  content: 'Needed gravel for a French drain project. They helped me pick the right size and delivered it the same week. The whole process from quote to delivery was seamless.',
  photo: 'https://cdn.magicpatterns.com/uploads/oTDFMkKEU78tjXHJCNVnma/Screenshot_20260507-195144.png',
  materialUsed: '7/8" Drain Rock',
  zone: 'Zone 3'
},
// ===== 206 — Seattle proper =====
{
  name: 'David W.',
  role: 'Homeowner',
  location: 'Seattle, WA',
  region: '206',
  content: 'Delivered exactly where I needed it in the city — tight alley access and all. The material calculator was super helpful; I ordered exactly what I needed for my patio base. Great quality road base.'
}, {
  name: 'Lisa M.',
  role: 'Homeowner',
  location: 'West Seattle, WA',
  region: '206',
  content: 'I had no idea how much gravel I needed, but their calculator nailed it. Got the 5/8 minus for my walkway and it looks amazing. Super fast delivery to West Seattle too.'
}, {
  name: 'Tom H.',
  role: 'Property Manager',
  location: 'Ballard, Seattle, WA',
  region: '206',
  content: 'We manage several rental properties around Seattle and use them for all our gravel and bark needs. Pricing is transparent and the delivery guys are always professional.',
  photo: 'https://cdn.magicpatterns.com/uploads/842UsR3B2N459pNY6iLg3A/PXL_20260430_160334850~2.jpg',
  materialUsed: '3-Way Topsoil',
  zone: 'Zone 2'
}, {
  name: 'Brian S.',
  role: 'Excavation Contractor',
  location: 'Burien, WA',
  region: '206',
  content: "We go through a lot of quarry rock and drain rock. They've been the most consistent supplier we've worked with around south Seattle. Fair prices, no games."
}, {
  name: 'Rachel K.',
  role: 'Homeowner',
  location: 'Shoreline, WA',
  region: '206',
  content: "First time ordering bulk material and they made it so easy. The driver called ahead and placed it exactly where I asked. Couldn't be happier with the 1.25 clear.",
  photo: 'https://cdn.magicpatterns.com/uploads/pqpwYUSWGeueYo493Urzhf/Screenshot_20260507-193040.png',
  materialUsed: '1.25" Clean',
  zone: 'Zone 2'
},
// ===== 425 — Eastside =====
{
  name: 'Amanda P.',
  role: 'Homeowner',
  location: 'Sammamish, WA',
  region: '425',
  content: 'Ordered 20 yards of Medium Bark for the front and back yards at our new build. Delivered within 24 hours and the driver placed the whole pile right where we asked — quality was way better than the big box stores.',
  photo: 'https://cdn.magicpatterns.com/uploads/n2CENmQoE2eukwieabfkD5/PXL_20260520_220049921.PORTRAIT.jpg',
  materialUsed: 'Medium Bark',
  volume: '20 yards',
  zone: 'Zone 3'
}, {
  name: 'Chris D.',
  role: 'Landscaping Contractor',
  location: 'Issaquah, WA',
  region: '425',
  content: "The bulk discount on bark saved us a ton on a large commercial project on the Eastside. Communication was great from quote to delivery. These guys know what they're doing."
}, {
  name: 'Marcus B.',
  role: 'Site Superintendent',
  location: 'Bellevue, WA',
  region: '425',
  content: "Needed 50 yards of 5/8 minus dropped at a tight commercial pad on 24-hour notice. Five trucks, all on time, each placed exactly on the stake. That's the kind of reliability that keeps our crews moving.",
  materialUsed: '5/8" Minus',
  volume: '50 yards',
  zone: 'Zone 3'
}, {
  name: 'Derek O.',
  role: 'Excavation Contractor',
  location: 'Redmond, WA',
  region: '425',
  content: 'Ordered 75 yards of quarry spalls for a retaining wall base — seven trucks back-to-back, all dispatched in under an hour. Pricing beat our usual supplier by close to a grand on this one job alone.',
  materialUsed: 'Quarry Spalls',
  volume: '75 yards',
  zone: 'Zone 3'
}, {
  name: 'Anthony G.',
  role: 'GC / Custom Homes',
  location: 'Maple Valley, WA',
  region: '425',
  content: "30 yards of 3-way topsoil for a new build's final grade — texted the order at 6:45am, first truck rolled in by 9. Net-30 billing makes my accountant happy too.",
  materialUsed: '3-Way Topsoil',
  volume: '30 yards',
  zone: 'Zone 3'
}];
function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
// Unified brand: 206Gravel serves the whole metro, so reviews are no longer
// filtered or fronted by a single domain. Instead we INTERLEAVE testimonials
// across all three areas (206 Seattle, 425 Eastside, 253 South Sound) so that
// every page of reviews visibly reflects coverage across the full service
// region rather than leading with one area. Each area is shuffled internally
// for variety, then round-robined together so 206/425/253 alternate.
function interleavedReviews(reviews: typeof allReviews): typeof allReviews {
  const buckets: Record<string, typeof allReviews> = {
    '206': shuffleArray(reviews.filter(r => r.region === '206')),
    '425': shuffleArray(reviews.filter(r => r.region === '425')),
    '253': shuffleArray(reviews.filter(r => r.region === '253'))
  };
  // Lead with Seattle (the unified brand's home area code), then round-robin.
  const order = ['206', '425', '253'];
  const result: typeof allReviews = [];
  let added = true;
  let i = 0;
  while (added) {
    added = false;
    for (const code of order) {
      const bucket = buckets[code];
      if (bucket[i]) {
        result.push(bucket[i]);
        added = true;
      }
    }
    i++;
  }
  return result;
}
const REVIEWS_PER_PAGE = 3;
export function Reviews() {
  const shuffledReviews = useMemo(() => interleavedReviews(allReviews), []);
  const totalPages = Math.ceil(shuffledReviews.length / REVIEWS_PER_PAGE);
  const [page, setPage] = useState(0);
  const currentReviews = shuffledReviews.slice(page * REVIEWS_PER_PAGE, (page + 1) * REVIEWS_PER_PAGE);
  const [lightboxPhoto, setLightboxPhoto] = useState<{
    src: string;
    alt: string;
    material?: string;
    zone?: string;
  } | null>(null);
  return <section className="relative py-28 dark:bg-[#161616] transition-colors duration-300 border-b border-stone-300 dark:border-[#27424a] bg-[#f5f3ef]" id="reviews" data-id="element-1543" data-mp="1pl799xsadn8c">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1544" data-mp="311dzi5qme0qk">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-16 gap-6" data-id="element-1545" data-mp="313qfidcti10z">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-1546" data-mp="ycvz0nzpwiz0">
            <p className="text-sm font-bold uppercase tracking-widest mb-3 text-[#04A05C]" data-id="element-1547" data-mp="1d4xtfsj0qjrn">
              Testimonials
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-extrabold text-stone-900 dark:text-stone-300 tracking-tight" data-id="element-1548" data-mp="1m4b7yzm01yj8">
              Trusted across the 206, 425 &amp; 253
              <span className="mt-2 block text-lg md:text-xl font-medium text-stone-400 dark:text-stone-500 font-[Montserrat,_sans-serif]" data-id="element-1549" data-mp="1r1l2uus5r2eg">
                Seattle, the Eastside &amp; South Sound
              </span>
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.1
        }} className="flex items-center gap-3" data-id="element-1550" data-mp="1pj1521r8g2v">
            <div className="flex -space-x-0.5" data-id="element-1551" data-mp="3gif9wtbt4eb5">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-[#f59e0b] text-[#f59e0b]" data-id="element-1552" data-mp="3bmzy06xd0shd" />)}
            </div>
            <span className="text-sm font-bold" data-id="element-1553" data-mp="d3awqtmsyhhr">
              <span className="text-[#f59e0b]" data-id="element-1554" data-mp="84zmihsli4z0">4.9</span>
              <span className="text-stone-500 dark:text-stone-400 font-medium ml-1" data-id="element-1555" data-mp="85hpdx9rjhfw">
                from 250+ reviews
              </span>
            </span>
          </motion.div>
        </div>

        {/* Reviews Grid */}
        <AnimatePresence mode="wait" data-id="element-1556" data-mp="3ueaj27gemb1c">
          <motion.div key={page} initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.35,
          ease: [0.16, 1, 0.3, 1]
        }} className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-1557" data-mp="2nw485fcgs7cr">
            {currentReviews.map((review, index) => <motion.div key={review.name} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: index * 0.08,
            ease: [0.16, 1, 0.3, 1]
          }} className="dark:bg-[#181818] p-8 rounded-2xl border border-stone-300 dark:border-[#282828] flex flex-col h-full shadow-sm dark:shadow-none bg-[#f7f5ef] relative" data-id="element-1558" data-mp="nvqikadzldqv" data-mpi={index}>
                {/* Volume badge — for large contractor orders */}
                {review.volume && <div className="absolute -top-3 right-6 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full dark:bg-[#f4f7f1] border border-stone-200 dark:border-transparent dark:text-stone-900 text-[10px] font-bold tracking-wider uppercase shadow-sm text-[#fffff1] bg-[#74A032]" data-id="element-1559" data-mp="11vsulfzm5cy7">
                    <Truck className="w-3 h-3" data-id="element-1560" data-mp="1j4u3mhv2suyl" />
                    {review.volume}
                  </div>}
                <div className="flex gap-1 mb-6" data-id="element-1561" data-mp="1o2n7h48wpcvp">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#f59e0b] text-[#f59e0b]" data-id="element-1562" data-mp="19dr0zbmi07x7" />)}
                </div>
                <p className="text-stone-700 dark:text-stone-300 leading-relaxed mb-4 flex-grow text-[15px]" data-id="element-1563" data-mp="1ec0wjnc4xajc">
                  "{review.content}"
                </p>
                {review.photo && <button type="button" onClick={() => setLightboxPhoto({
              src: review.photo!,
              alt: `Project by ${review.name}`,
              material: review.materialUsed,
              zone: review.zone
            })} className="inline-flex items-center gap-1.5 text-xs font-bold text-brand-accent hover:text-brand-accentHover transition-colors mb-6 self-start" data-id="element-1564" data-mp="15dyst010o3sd">
                    <ImageIcon className="w-3.5 h-3.5" data-id="element-1565" data-mp="2prpmmnkoqpod" />
                    View photo
                    {review.materialUsed && <span className="text-stone-500 dark:text-stone-400 font-medium ml-1" data-id="element-1566" data-mp="2oceh7qqr4yuh">
                        · {review.materialUsed}
                      </span>}
                  </button>}
                {!review.photo && review.materialUsed && <div className="inline-flex items-center gap-1.5 text-xs font-bold text-stone-500 dark:text-stone-400 mb-6 self-start" data-id="element-1567" data-mp="2ef8qwkpypbvb">
                    <span className="font-medium" data-id="element-1568" data-mp="372co43itclwj">
                      Material: {review.materialUsed}
                    </span>
                  </div>}
                <div className="flex items-center gap-4 mt-auto pt-6 border-t border-stone-400 dark:border-[#333333]" data-id="element-1569" data-mp="3252zur75ugaa">
                  <div className="w-10 h-10 rounded-full dark:bg-[#282828] flex items-center justify-center text-stone-700 dark:text-stone-200 font-bold font-heading bg-[#FFFFFC]" data-id="element-1570" data-mp="2taoh2enf8nmf">
                    {review.name.charAt(0)}
                  </div>
                  <div data-id="element-1571" data-mp="3l12obs0xj1p4">
                    <p className="text-stone-900 dark:text-stone-200 font-bold text-sm" data-id="element-1572" data-mp="3kzrk5r3knrxh">
                      {review.name}
                    </p>
                    <p className="text-stone-600 dark:text-stone-400 text-xs" data-id="element-1573" data-mp="1chj9luq5shi7">
                      {review.role} • {review.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </motion.div>
        </AnimatePresence>

        {/* Pagination */}
        <div className="flex items-center justify-center gap-4 mt-10" data-id="element-1574" data-mp="1qh11iiyr4avs">
          <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page === 0} className="p-2 rounded-full border border-stone-600 dark:border-[#3a3b3e] text-stone-800 dark:text-stone-300 hover:text-stone-900 dark:hover:text-stone-200 hover:border-stone-700 dark:hover:border-[#4b4c4f] transition-colors disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-1575" data-mp="1vgx5wjbd24bv">
            <ChevronLeft className="w-5 h-5" data-id="element-1576" data-mp="29aembv8r30xo" />
          </button>

          <div className="flex gap-2" data-id="element-1577" data-mp="2e8pywdqfjpjl">
            {Array.from({
            length: totalPages
          }).map((_, i) => <button key={i} onClick={() => setPage(i)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === page ? 'bg-brand-orange scale-110' : 'bg-stone-300 dark:bg-stone-500 hover:bg-stone-400 dark:hover:bg-stone-400'}`} data-id="element-1578" data-mp="20jmtsicv25lh" data-mpi={i} />)}
          </div>

          <button onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))} disabled={page === totalPages - 1} className="p-2 rounded-full border border-stone-600 dark:border-[#3a3b3e] text-stone-800 dark:text-stone-300 hover:text-stone-900 dark:hover:text-stone-200 hover:border-stone-700 dark:hover:border-[#4b4c4f] transition-colors disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-1579" data-mp="25b4myk8n71vw">
            <ChevronRight className="w-5 h-5" data-id="element-1580" data-mp="1mlg59stsxhyh" />
          </button>
        </div>
      </div>

      {/* Photo Lightbox */}
      <AnimatePresence data-id="element-1581" data-mp="32yn4okka7ec1">
        {lightboxPhoto && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={() => setLightboxPhoto(null)} className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 cursor-zoom-out" data-id="element-1582" data-mp="331j30a01k510">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: [0.16, 1, 0.3, 1]
        }} onClick={e => e.stopPropagation()} className="relative max-w-4xl w-full cursor-default" data-id="element-1583" data-mp="2wjoahn18xdgy">
              <button type="button" onClick={() => setLightboxPhoto(null)} className="absolute -top-12 right-0 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md flex items-center justify-center text-white transition-colors" aria-label="Close photo" data-id="element-1584" data-mp="3fiabl1wrj4kv">
                <X className="w-5 h-5" data-id="element-1585" data-mp="b1ppzv97jx0y" />
              </button>
              <img src={lightboxPhoto.src} alt={lightboxPhoto.alt} className="w-full h-auto max-h-[85vh] object-contain rounded-2xl shadow-2xl" data-id="element-1586" data-mp="fvkedbzrd06d" />
              {(lightboxPhoto.material || lightboxPhoto.zone) && <div className="absolute bottom-4 left-4 flex gap-2" data-id="element-1587" data-mp="lpz4fyqxvbwk">
                  {lightboxPhoto.material && <span className="bg-black/70 backdrop-blur-md text-white text-xs font-bold px-3 py-1.5 rounded-md" data-id="element-1588" data-mp="gorwnzosqcpw">
                      {lightboxPhoto.material}
                    </span>}
                  {lightboxPhoto.zone && <span className="bg-brand-orange/90 backdrop-blur-md text-white text-xs font-bold px-3 py-1.5 rounded-md" data-id="element-1589" data-mp="6t82bhpvrm39">
                      {lightboxPhoto.zone}
                    </span>}
                </div>}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}